import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiActivity, FiShield, FiZap, FiEye } = FiIcons;

const Hero = () => {
  return (
    <motion.section 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="text-center py-8 sm:py-12 mb-8"
    >
      <div className="max-w-4xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="mb-6"
        >
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            Check Website Status
            <span className="block text-primary-600 dark:text-primary-400">Instantly & Privately</span>
          </h1>
          
          <p className="text-lg sm:text-xl text-gray-600 dark:text-gray-300 mb-8 leading-relaxed">
            Monitor website availability, performance, and security with comprehensive reports. 
            <span className="block mt-2 text-base sm:text-lg">
              <strong className="text-primary-600 dark:text-primary-400">Privacy-focused</strong> - 
              No data stored, no tracking, just instant results.
            </span>
          </p>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-8"
        >
          <div className="bg-white dark:bg-gray-800 rounded-lg p-4 shadow-md border border-gray-200 dark:border-gray-700">
            <SafeIcon icon={FiZap} className="h-6 w-6 text-yellow-500 mx-auto mb-2" />
            <h3 className="text-sm sm:text-base font-semibold text-gray-900 dark:text-white mb-1">
              Instant Results
            </h3>
            <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
              Get comprehensive status reports in seconds
            </p>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg p-4 shadow-md border border-gray-200 dark:border-gray-700">
            <SafeIcon icon={FiShield} className="h-6 w-6 text-green-500 mx-auto mb-2" />
            <h3 className="text-sm sm:text-base font-semibold text-gray-900 dark:text-white mb-1">
              Privacy First
            </h3>
            <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
              No data collection or storage
            </p>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg p-4 shadow-md border border-gray-200 dark:border-gray-700">
            <SafeIcon icon={FiActivity} className="h-6 w-6 text-blue-500 mx-auto mb-2" />
            <h3 className="text-sm sm:text-base font-semibold text-gray-900 dark:text-white mb-1">
              Deep Analysis
            </h3>
            <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
              Headers, security, DNS, and more
            </p>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg p-4 shadow-md border border-gray-200 dark:border-gray-700">
            <SafeIcon icon={FiEye} className="h-6 w-6 text-purple-500 mx-auto mb-2" />
            <h3 className="text-sm sm:text-base font-semibold text-gray-900 dark:text-white mb-1">
              Multi-Method
            </h3>
            <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
              Multiple fallback checking methods
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4 inline-block"
        >
          <div className="flex items-center space-x-2 text-green-800 dark:text-green-400">
            <SafeIcon icon={FiShield} className="h-4 w-4" />
            <span className="text-sm font-medium">
              100% Privacy Focused - Your checks remain completely private
            </span>
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Hero;